
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.71 6.243A.71.71 0 010 5.536V.708A.707.707 0 01.71 0h4.839a.71.71 0 01.71.708.707.707 0 01-.71.707h-4.13v4.12a.707.707 0 01-.71.708z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M.71 6.243A.71.71 0 010 5.536V.708A.707.707 0 01.71 0h4.839a.71.71 0 01.71.708.707.707 0 01-.71.707h-4.13v4.12a.707.707 0 01-.71.708zM5.549 23.943H.709A.71.71 0 010 23.236v-4.84a.707.707 0 01.71-.707.71.71 0 01.708.707v4.132h4.13a.71.71 0 01.71.708.707.707 0 01-.71.707z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M5.549 23.943H.709A.71.71 0 010 23.236v-4.84a.707.707 0 01.71-.707.71.71 0 01.708.707v4.132h4.13a.71.71 0 01.71.708.707.707 0 01-.71.707zM23.29 23.943h-4.85a.71.71 0 01-.71-.707.707.707 0 01.71-.708h4.141v-4.132a.706.706 0 01.71-.707.712.712 0 01.655.436.706.706 0 01.054.271v4.84a.706.706 0 01-.71.707zM23.29 6.243a.71.71 0 01-.709-.707v-4.12H18.44a.71.71 0 01-.71-.708.707.707 0 01.71-.708h4.85a.71.71 0 01.71.708v4.828a.706.706 0 01-.71.707zM7.16 7.851a.708.708 0 01-.499-.21L3.433 4.428a.708.708 0 01.502-1.21.71.71 0 01.502.208l3.223 3.22a.707.707 0 01-.503 1.21l.003-.004z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16.84 7.851a.71.71 0 01-.697-.846.707.707 0 01.195-.362l3.237-3.218a.711.711 0 011.212.5.708.708 0 01-.208.502l-3.237 3.215a.706.706 0 01-.502.21zM20.066 20.726a.707.707 0 01-.491-.207l-3.237-3.218a.708.708 0 01.502-1.21.71.71 0 01.502.208l3.226 3.23a.707.707 0 01-.503 1.208v-.011zM3.935 20.725a.71.71 0 01-.688-.837.707.707 0 01.186-.36l3.228-3.23a.71.71 0 011.18.512.706.706 0 01-.181.49L4.437 20.52a.707.707 0 01-.502.206z","fill":"currentColor"}})])
          )
        }
      }
    